var map = {
	"./worklist-status-1.svg": 72969,
	"./worklist-status-2.svg": 57882,
	"./worklist-status-3.svg": 76939,
	"./worklist-status-4.svg": 14788,
	"./worklist-status-5.svg": 69509,
	"./worklist-status-6.svg": 70374,
	"./worklist-status-default.svg": 8911
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62560;